function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
export default (({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM20 12C20 13.18 19.73 14.31 19.27 15.32L15.05 11.1C15.37 10.56 15.57 9.94 15.57 9.26C15.57 7.28 13.96 5.68 11.99 5.68C11.31 5.68 10.69 5.88 10.15 6.2L8.68 4.73C9.69 4.27 10.81 4 12 4C16.41 4 20 7.59 20 12ZM13.53 9.58L11.66 7.71C11.77 7.69 11.88 7.67 11.99 7.67C12.86 7.67 13.57 8.38 13.57 9.25C13.57 9.36 13.56 9.47 13.53 9.58ZM12 20C10.23 20 8.6 19.41 7.27 18.44C8.15 16.67 10.01 15.49 11.96 15.49C12.78 15.49 13.57 15.71 14.29 16.08L11.71 13.5C9.27 13.58 7.05 14.92 5.77 17.01C4.67 15.64 4 13.9 4 12.01C4 9.52 5.15 7.29 6.94 5.82L18.19 17.07C16.72 18.86 14.49 20.01 12 20.01V20Z",
  fill: fill || 'currentColor'
})));
//# sourceMappingURL=ProfileOff.js.map